import { Box, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useForm } from "react-hook-form";
import FormData from "components/FormFieldData";

import fields from "./fields";
import { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import { Db } from "helper/db";
import {useLocation, useNavigate} from "react-router";
import Chargement from "components/Chargement";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddAssociation = () => {
  const { control, register, handleSubmit, setValue } = useForm();
  let query = useQuery();
  let associationId;
  const navigate = useNavigate();

  if (query.get("ref")) {
    associationId = query.get("ref");
  }

  const [data, loadassociation, cls] = useFetch("get_association/");
  const [dataEvol, loadSetassociation, clsassociation] = useFetch("association");

  useEffect(() => {
    (async function () {
      if (!!associationId && associationId !== null) {
        loadassociation({}, "get", "json", false, false, associationId).then(
          (resp) => {
            if (resp) {
              let { id, ...other } = resp;

              for (let item in other) {
                setValue(item, other[item], { shouldTouch: true });
              }
            }
          }
        );
      }
    })();

    return () => {
      cls.cancel();
    };
  }, []);

  const sendData = async (dataSend) => {
    console.log(
      "🚀 ~ file: index.jsx ~ line 18 ~ sendData ~ dataSend",
      dataSend
    );

    let _param = !!associationId && associationId !== null ? `/${associationId}?_method=PUT`  : "";
    loadSetassociation(dataSend, "post", "json", true, true, _param).then((rep) => {
      if (rep) {
        navigate("/association");
        // setDataList(initList);
        // setTimeout(closeDrawer(), 500);
      }
    });
  };

  return (
    <div>
      <Box p={2} pb={0}>
        <Typography variant="h5" component="h1" fontWeight="bold">
          Ajout ou modification association
        </Typography>
      </Box>

      <Chargement loading={data.loading}/>

      <form>
        <Box
          p={2}
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat( auto-fill, minmax(280px, 1fr) )",
            gap: "15px",
            overflow: "hidden",
          }}
        >
          {fields.map((props, key) => (
            <FormData
              key={key}
              {...props}
              {...register(props.name)}
              control={control}
            />
          ))}
        </Box>
        <Box p={2}>
          <LoadingButton
            onClick={handleSubmit(sendData)}
            color="primary"
            variant="contained"
            loading={dataEvol.loading}
          >
            Sauvegarder
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default AddAssociation;
